var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4H1C0.447715 4 0 4.44772 0 5V15C0 15.5523 0.447715 16 1 16H1.37731C2.11038 15.0855 3.23681 14.5 4.5 14.5C5.76319 14.5 6.88963 15.0855 7.62269 16H13.5C14.0523 16 14.5 15.5523 14.5 15V5C14.5 4.44772 14.0523 4 13.5 4ZM16.0022 9C16.0022 8.44772 16.4499 8 17.0022 8H20.4054C20.6595 8 20.904 8.09674 21.0894 8.27056L23.684 10.7037C23.8856 10.8927 24 11.1568 24 11.4332V15C24 15.5523 23.5523 16 23 16H22.6227C21.8896 15.0855 20.7632 14.5 19.5 14.5C18.3019 14.5 17.2268 15.0267 16.4937 15.8613C16.1995 15.6872 16.0022 15.3666 16.0022 15V9ZM4.5 21C5.88071 21 7 19.8807 7 18.5C7 17.1193 5.88071 16 4.5 16C3.11929 16 2 17.1193 2 18.5C2 19.8807 3.11929 21 4.5 21ZM22 18.5C22 19.8807 20.8807 21 19.5 21C18.1193 21 17 19.8807 17 18.5C17 17.1193 18.1193 16 19.5 16C20.8807 16 22 17.1193 22 18.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.56a19667069447a1ef1f35de50c45b9c.svg";
export { ForwardRef as ReactComponent };